import React, { useEffect, useCallback } from 'react'
import { Select, Button, Table, Tooltip } from 'antd'
import { connect } from 'dva'
import { find } from 'lodash'
import PageWrapper from '@/components/PageWrapper'
import PageTable from '@/components/PageTable'
import './Message.module.less'

const { Option } = Select
const { Column } = Table

const Message = ({
  dispatch,
  messageType,
  messagePagination,
  messageData,
  selectedRowKeys,
  messageCategories,
}) => {
  useEffect(() => {
    dispatch({
      type: 'center/getMessageList',
    })
    dispatch({
      type: 'center/getMessageCategories',
    })
  }, [dispatch])

  const handleChangeMessageType = useCallback(
    (messageType) => {
      dispatch({
        type: 'center/save',
        payload: {
          messageType,
        },
      })
      dispatch({
        type: 'center/save',
        payload: {
          selectedRowKeys: [],
        },
      })
      dispatch({
        type: 'center/getMessageList',
      })
    },
    [dispatch]
  )

  const handleTableChange = (option) => {
    dispatch({
      type: 'center/save',
      payload: {
        messagePagination: {
          ...messagePagination,
          current: option.current,
          pageSize: option.pageSize,
        },
      },
    })
    dispatch({
      type: 'center/getMessageList',
    })
  }

  const onSelectChange = useCallback(
    (selectedRowKeys) => {
      dispatch({
        type: 'center/save',
        payload: {
          selectedRowKeys,
        },
      })
    },
    [dispatch]
  )

  const handleChangeMessageStatus = useCallback(() => {
    dispatch({
      type: 'center/updateMessageStatus',
    })
  }, [dispatch])

  const handleDeleteMessage = useCallback(() => {
    dispatch({
      type: 'center/deleteMessage',
    })
  }, [dispatch])

  const getLabel = useCallback(
    (id) => {
      const filter = find(messageCategories, (x) => x.id === id)
      return filter ? filter.name : ''
    },
    [messageCategories]
  )

  return (
    <PageWrapper
      subTitle={
        <div styleName="query-box">
          <span styleName="title">我的新消息：</span>
          <Select
            size="small"
            value={messageType}
            onChange={handleChangeMessageType}
            style={{ width: '118px' }}
          >
            <Option value="">全部</Option>
            {messageCategories.map((it) => (
              <Option key={it.id} value={it.id}>
                {it.name}
              </Option>
            ))}
          </Select>
        </div>
      }
    >
      <div style={{ marginTop: '18px' }}>
        <Button
          disabled={selectedRowKeys.length === 0}
          onClick={handleChangeMessageStatus}
          type="primary"
        >
          全部标为已读
        </Button>
        <Button
          disabled={selectedRowKeys.length === 0}
          onClick={handleDeleteMessage}
          style={{ marginLeft: '30px' }}
          type="default"
        >
          删除所选信息
        </Button>
        <PageTable
          // loading={loading}
          rowSelection={{
            selectedRowKeys,
            onChange: onSelectChange,
          }}
          onChange={handleTableChange}
          pagination={messagePagination}
          rowKey="id"
          dataSource={messageData}
          style={{ marginTop: '30px' }}
        >
          <Column
            width="130px"
            title="消息主题"
            dataIndex="categoryId"
            key="categoryId"
            render={(text) => <span>{getLabel(text)}</span>}
          />
          <Column
            ellipsis
            title="消息内容"
            dataIndex="content"
            key="content"
            render={(text, record) => (
              <Tooltip title={text}>
                <div styleName="content">
                  <i
                    styleName={`dot ${record.isRead === 1 ? 'is-read' : ''}`}
                  />
                  <span>{text}</span>
                </div>
              </Tooltip>
            )}
          />
          <Column
            width="130px"
            title="时间"
            dataIndex="createdAt"
            key="createdAt"
          />
        </PageTable>
      </div>
    </PageWrapper>
  )
}

export default connect(({ center }) => {
  return {
    messageType: center.messageType,
    messagePagination: center.messagePagination,
    messageData: center.messageData,
    selectedRowKeys: center.selectedRowKeys,
    messageCategories: center.messageCategories,
  }
})(Message)
